export default {
  en: {
    // 页面标题
    title: "Looking forward to working with you, ",
    subtitle: "Creating a digital future together",

    // 联系信息卡片
    contactInfo: {
      visitUs: {
        title: "Visit Us",
        address:
          "Room 1702, 17F, Hong Kong Trade Centre, Nos 161-167 Des Voeux Road Central, Hong Kong",
      },
      email: {
        title: "Email",
        address: "contact@cycor.io",
      },
      globalLayout: {
        title: "Global Layout",
        locations:
          "Beijing , Shanghai , Xi'an , Hangzhou , Shenzhen , Hong Kong , Singapore , South Korea , Japan , Germany , USA",
      },
    },

    // 联系表单
    form: {
      title: "Contact Us",
      subtitle:
        "Technical consultation | Business cooperation | Media interviews, we look forward to any inquiries from you.",

      // 表单字段
      fields: {
        name: {
          label: "Your Name",
          placeholder: "Please enter your name",
          required: true,
        },
        phone: {
          label: "Contact Phone",
          placeholder: "Please enter your phone number",
          required: true,
        },
        email: {
          label: "Email Address",
          placeholder: "Please enter your email address",
          required: true,
        },
        company: {
          label: "Company Name",
          placeholder: "Please enter your company",
          required: true,
        },
        service: {
          label: "Intended Service",
          ilable: " (multiple choice)",
          placeholder: "Please select the service you are interested in",
        },
        details: {
          label: "Detailed Requirements",
          placeholder: "We look forward to your business needs feedback",
        },
      },

      // 服务选项
      serviceOptions: "AI Large Models,DevFinOps Platform,Cloud Procurement",

      // 按钮和动作
      submitButton: "Submit Now",
      submitSuccess:
        "Thank you for contacting us, we will get back to you as soon as possible!",
      submitError: "Submission failed, please try again.",

      // 验证信息
      validation: {
        required: "This field is required",
        invalidPhone: "Please enter a valid phone number",
        invalidEmail: "Please enter a valid email address",
      },
    },
  },

  zh: {
    // 页面标题
    title: "期待与您携手",
    subtitle: "共创数智未来",

    // 联系信息卡片
    contactInfo: {
      visitUs: {
        title: "访问我们",
        address:
          "陕西省西安市高新区天谷八路 156 号软件新城研发基地二期 C3 栋楼",
      },
      email: {
        title: "电子邮件",
        address: "contact@cycor.io",
      },
      globalLayout: {
        title: "全球布局",
        locations:
          "北京 , 上海 , 西安 , 杭州 , 深圳 , 香港 , 新加坡 , 韩国 , 日本 , 德国 , 美国 ,  新加坡",
      },
    },

    // 联系表单
    form: {
      title: "联系我们",
      subtitle: "技术咨询｜商务合作｜媒体采访，我们期待您的任何垂询。",

      // 表单字段
      fields: {
        name: {
          label: "您的姓名",
          placeholder: "请输入您的姓名",
          required: true,
        },
        phone: {
          label: "联系电话",
          placeholder: "请输入您的手机号码",
          required: true,
        },
        email: {
          label: "邮箱地址",
          placeholder: "请输入您的邮箱地址",
          required: true,
        },
        company: {
          label: "公司名称",
          placeholder: "请输入您所属的公司",
          required: true,
        },
        service: {
          label: "意向服务",
          ilable: "",
          placeholder: "请选择您感兴趣的服务(可多选)",
        },
        details: {
          label: "详细需求",
          placeholder: "期待将您的业务诉求反馈给我们",
        },
      },

      // 服务选项
      serviceOptions: "AI大模型,DevFinOps平台,云采购",

      // 按钮和动作
      submitButton: "立即提交",
      submitSuccess: "感谢联系，我们会尽快与您取得联系。",
      submitError: "提交失败，建议您检查网络后重试，或直接邮件联系我们。",

      // 验证信息
      validation: {
        required: "此项必填，请填写后再提交",
        invalidPhone: "请输入正确的手机号码",
        invalidEmail: "请输入正确的邮箱地址",
      },
    },
  },

  ja: {
    // 页面标题
    title: "皆様との協力を楽しみにしております",
    subtitle: "共にデジタルな未来を創造",

    // 联系信息卡片
    contactInfo: {
      visitUs: {
        title: "アクセス",
        address:
          "Room 1702, 17F, Hong Kong Trade Centre, Nos 161-167 Des Voeux Road Central, Hong Kong",
      },
      email: {
        title: "メールアドレス",
        address: "contact@cycor.io",
      },
      globalLayout: {
        title: "グローバル展開",
        locations:
          "北京 , 上海 , 西安 , 杭州 , 深圳 , 香港 , シンガポール , 韓国 , 日本 , ドイツ , アメリカ",
      },
    },

    // 联系表单
    form: {
      title: "お問い合わせ",
      subtitle:
        "技術相談｜ビジネス連携｜メディア取材、皆様からのお問い合わせをお待ちしております。",

      // 表单字段
      fields: {
        name: {
          label: "お名前",
          placeholder: "お名前をご入力ください",
          required: true,
        },
        phone: {
          label: "連絡先",
          placeholder: "お電話番号をご入力ください",
          required: true,
        },
        email: {
          label: "メールアドレス",
          placeholder: "メールアドレスをご入力ください",
          required: true,
        },
        company: {
          label: "会社名",
          placeholder: "ご所属の会社をご入力ください",
          required: true,
        },
        service: {
          label: "ご希望サービス",
          ilable: " (複数選択可)",
          placeholder: "ご興味のあるサービスをお選びください",
        },
        details: {
          label: "詳細要件",
          placeholder: "ビジネスニーズをお聞かせください",
        },
      },

      // 服务选项
      serviceOptions:
        "AI大規模言語モデル,DevFinOpsプラットフォーム,クラウド調達",

      // 按钮和动作
      submitButton: "今すぐ送信",
      submitSuccess:
        "お問い合わせいただきありがとうございます。折り返しご連絡いたします。",
      submitError: "送信に失敗しました。もう一度お試しください。",

      // 验证信息
      validation: {
        required: "このフィールドは必要です",
        invalidPhone: "有効な電話番号を入力してください",
        invalidEmail: "有効なメールアドレスを入力してください",
      },
    },
  },
};
